



import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({})
export default class MdiComponent extends Vue {

  @Prop(String)
  public iconName!: string;

}


